<script setup lang="ts">
import type { PropType } from 'vue';
import type { IconName } from '@mop/ui2/types';
import useUi2Config from '@mop/ui2/composables/useUi2Config';
const { svgIcons } = useUi2Config();

defineOptions({
  name: 'Ui2Icon',
});

const props = defineProps({
  name: {
    type: String as PropType<IconName>,
    required: true,
  },
  width: {
    type: Number,
    required: true,
  },
  height: {
    type: Number,
    required: true,
  },
  color: {
    type: String,
    default: '',
  },
  label: {
    type: String,
    default: '',
  },
});
const SvgIconComponent: undefined | (() => Promise<{ default: string }>) = svgIcons[`../../icons/${props.name}.svg`];
const svgRaw = SvgIconComponent ? await SvgIconComponent() : null;
</script>

<template>
  <span
    v-if="svgRaw"
    :key="name"
    role="img"
    :class="`ui-svg-icon ${color}`"
    :width="width"
    :aria-hidden="!label"
    :aria-label="label ? `Icon: ${label}` : undefined"
    :height="height"
    :style="{ width: `${width}px`, height: `${height}px`, 'min-width': `${width}px`, 'min-height': `${height}px` }"
    v-html="svgRaw"
  />
</template>

<style lang="scss">
.ui-svg-icon {
  display: inline-flex;
}

.ui-svg-icon svg {
  width: 100%;
  height: 100%;
  display: block;
  fill: currentColor;
}
</style>
